import React, { Component } from 'react';
import Study from '../studies/Study';

class Experiences extends Component {
  render() {
    return (
    <div className="page" id={this.props.id}>
        <div className="page-container">
            <h2>Experiences</h2>

            <Study 
            title="Software Developper (Internship)" 
            description="MFX | LORIA" 
            link="https://mfx.loria.fr"
            info={
            <div>
              <b>Mission : </b> <br/>
              Development of a IceSL Plugin in C++ allowing the print of 3D pieces with strictely continuous deposit 
            </div>
            } 
            location="Nancy | France" 
            date="April 2022 - July 2022"
            />

            <Study 
            title="Web Developper (Internship)" 
            description="DANE Nancy-Metz" 
            link="https://dane.ac-nancy-metz.fr"
            info={
              <div>
                <b>Missions : </b>
                <ul>
                  <li>Development of a page recolt system in Wordpress</li>
                  <li>Development of a user data recolt system in Wordpress</li>
                  <li>Development of a search engine for the LUNE portal in Symfony</li>
                </ul>
              </div>
              } 
            location="Nancy | France" 
            date="May 2021 - July 2021"
            />

        </div>
    </div>
    );
  }
}

export default Experiences;